(function () {
  if (window.__promoGuard) return; window.__promoGuard = true;

  function allow() {
    if (document.documentElement.classList.contains('promo-ok')) return;
    document.documentElement.classList.add('promo-ok');
    try { document.dispatchEvent(new Event('promo:allowed')); } catch (e) {}
  }

  // Real user intent
  document.addEventListener('click', allow, { once: true });
  document.addEventListener('keydown', allow, { once: true });
  document.addEventListener('touchstart', allow, { once: true, passive: true });
  function onScroll(){ if (window.scrollY > 120) { allow(); window.removeEventListener('scroll', onScroll); } }
  window.addEventListener('scroll', onScroll, { passive: true });
})();



